<template>
  <div>
    <v-row v-if="item.id" dense>
      <!-- {{item}} -->
      <v-col v-if="hasInformation" cols="4">
        <h2><strong>Conteúdo da Evolução</strong></h2>
        <p></p>
        <p v-if="item.profissional.apelido"> <strong>Profissional: </strong> {{ item.profissional.apelido }}</p>
        <p v-if="item.timestamp"> <strong>Data da Evolução:   </strong> {{ formatTimestampDiaSemana(item.timestamp) }} - {{formatTime(item.hora_inicio)}} às {{formatTime(item.hora_fim)}}</p>
        <p > <strong>Altura:</strong> {{ item.altura ? `${item.altura} m` : 'Não Cadastrado' }}   <strong>  Peso: </strong> {{ item.peso ? `${item.peso} kg` : 'Não Cadastrado' }} </p>
        <p v-if="item.quadro_clinico && (item.especialidade.id === 3 || item.especialidade.id === 4) "> <strong>Histórico Clínico:   </strong> {{ item.quadro_clinico }}</p>
        <p v-if="item.diagnostico_clinico"> <strong>Diagnostico Clínico:   </strong> {{ item.diagnostico_clinico }}</p>
        <p v-if="item.exame_fisico"> <strong>Exame Físico:   </strong> {{ item.exame_fisico }}</p>
        <p v-if="item.conduta"> <strong>Conduta:   </strong> {{ item.conduta }}</p>
        <p v-if="item.texto_evolucao"><strong> Texto da Evolução:   </strong> {{ item.texto_evolucao }}</p>
        <p v-if="item.texto_meta"><strong>Texto da Meta:   </strong> {{ item.texto_meta }}</p>
        <p v-if="item.texto_info"> <strong>Texto da Informação para Prorrogação:   </strong> {{ item.texto_info }}</p>
        <p v-if="item.timestamp_sign"> <strong>Data da Coleta da Assinatura: </strong> {{ formatTimestamp(item.timestamp_sign) }}</p>
        <p v-if="item.arquivos.length"> <strong>Anexos: </strong> Possui {{item.arquivos.length }} arquivo(s) anexado a essa evolução </p>
      </v-col>
      <v-col v-else>
        <p v-if="!item.procedimento.especial"><strong>Sem Evolução lançada</strong></p>
      </v-col>

      <v-col cols="4" v-if="!item?.nead_abemid">
        <h2 v-if="(item?.profissional?.especialidade?.id === 4 || item?.profissional?.especialidade?.id === 3 || item?.profissional?.especialidade?.id === 1) "><strong>mais informações...</strong></h2>
        <p></p>
        <!-- Respirador -->
        <p v-if=" item?.profissional?.especialidade?.id === 1 || item?.profissional?.especialidade?.id === 4 || item?.profissional?.especialidade?.id === 3"><strong>Possui Respirador: </strong> {{ item?.paciente.respirador ? 'SIM':'NÃO' }}</p>
        <p v-if=" item?.profissional?.especialidade?.id === 1 && item?.paciente.respirador">  <strong>Uso do Respirador: </strong> De forma {{ item.uso_respirador }}  </p>
        <p v-if="( item?.profissional?.especialidade?.id === 1) && item?.paciente.respirador"><strong>Modelo:</strong> {{ item?.tipo_ventilador_mecanico?.tipo ? item?.tipo_ventilador_mecanico?.tipo : 'Não Cadastrado' }} - <strong>Modo Ventilatório:</strong> {{ item?.modo_ventilatorio?.tipo ? item?.modo_ventilatorio?.tipo : 'Não Cadastrado' }}</p>
        <p v-if="( item?.profissional?.especialidade?.id === 1) && item?.paciente.respirador">
          <strong>VC:</strong> {{ item?.ventilador_vc }} 
          - <strong>Ipap:</strong> {{ item?.ventilador_ipap ? item?.ventilador_ipap : 'Não Cadastrado' }} 
          - <strong>Epap:</strong> {{ item?.ventilador_epap ? item?.ventilador_epap : 'Não Cadastrado' }} 
          - <strong>FR:</strong> {{ item?.ventilador_fr ? item?.ventilador_fr : 'Não Cadastrado' }} 
          - <strong>TINS:</strong> {{ item?.ventilador_tins ? item?.ventilador_tins : 'Não Cadastrado' }} </p>
        <!-- TQT -->
          <br>
        <p v-if="item?.profissional?.especialidade?.id === 4 || item?.profissional?.especialidade?.id === 3"><strong>Possui TQT: </strong> {{ item?.tqt ? "SIM": "NÃO" }}</p>
        <p v-if="(item?.profissional?.especialidade?.id === 4 || item?.profissional?.especialidade?.id === 3) && item?.tqt"> <strong>Modelo da TQT:   </strong> {{ item?.tqt?.modelo }} - <strong>Número da TQT:</strong> {{ item?.numeracao_tqt }}</p>
        <br>
        <p v-if="item?.profissional?.especialidade?.id === 4 || item?.profissional?.especialidade?.id === 3"><strong>Possui Sonda / GTT: </strong> {{ item?.via_alimentacao_gtt ? "SIM" : "NÃO" }}</p>
        <p v-if="(item?.profissional?.especialidade?.id === 4 || item?.profissional?.especialidade?.id === 3 ) && item?.via_alimentacao_gtt"><strong>Modelo:   </strong> {{ item?.via_alimentacao_gtt?.tipo ? item?.via_alimentacao_gtt?.tipo : 'Não Cadastrado' }} - <strong>Tamanho:   </strong> {{ item?.tamanho_gtt ? item?.tamanho_gtt : 'Não Cadastrado'}}</p>
        <!-- GTT -->
        <br>
        <p v-if="item?.profissional?.especialidade?.id === 4 || item?.profissional?.especialidade?.id === 3"><strong>Sinais Vitais:</strong></p>
        <p v-if="item?.profissional?.especialidade?.id === 4 || item?.profissional?.especialidade?.id === 3"><strong>PA:</strong> {{ item?.sinais_vitais_pa ? item?.sinais_vitais_pa : 'Não Cadastrado' }} 
          - <strong>FC:</strong> {{ item?.sinais_vitais_fc ? item?.sinais_vitais_fc : 'Não Cadastrado'}} 
          - <strong>FR:</strong> {{ item?.sinais_vitais_fr ? item?.sinais_vitais_fr : 'Não Cadastrado'}} 
          - <strong>Temperatura:</strong> {{ item?.sinais_vitais_temperatura ? item?.sinais_vitais_temperatura : 'Não Cadastrado'}} 
          - <strong>Saturação:</strong> {{ item?.sinais_vitais_saturacao ?  item?.sinais_vitais_saturacao : 'Não Cadastrado'}} 
          - <strong>Nivel de Conciência:</strong> {{ item?.sinais_vitais_nivel_conciencia?.tipo ? item?.sinais_vitais_nivel_conciencia?.tipo : 'Não Cadastrado'}} 
        </p>
      </v-col>    

      <v-col cols="4" v-if="!item.procedimento.especial">
        <h2><strong>Informações Complementares</strong></h2>
        <p></p>
        <p> <strong>Pagamento Prestador: </strong> {{ item.pagamento ? 'SIM': 'NÃO' }}</p>
        <p> <strong>Valor do Prestador: </strong> {{ formatCurrencyZero(item.valor_pagamento) }}</p>
        <p> <strong>Offline: </strong> {{ item.offline ? 'SIM': 'NÃO' }}</p>
        <!-- <p> <strong>Nome na Contratante: </strong> {{ item.procedimento.nomecomercial }}</p> -->
        <p> <strong>Quantidade: </strong> {{ item.quantidade }}</p>
        <p> <strong>Código do Procedimento: </strong> {{ item.procedimento.codigo }}</p>
        <p> <strong>Aditivo: </strong> {{ item.aditivo ? 'SIM': 'NÃO' }}</p>
        <p v-if="item.aditivo"> <strong>Nº Aditivo: </strong> {{ item.nr_aditivo }}</p>
        <p v-if="item.aditivo"> <strong>Data Início do Aditivo: </strong> {{ formatDate(item.data_aditivo) }}</p>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import UtilsFunc from "../../../service/utilsFunc";

export default {
  name: "Evolucaoexpand",
  data: () => UtilsFunc.withCRUDUtils({
    isLoading: true,
  
  }), 
  props: {
    item: Object,
  },
  methods: {
    formatTimestamp(timestamp) {
        let date = new Date(timestamp);
        let day = String(date.getDate()).padStart(2, '0');
        let month = String(date.getMonth() + 1).padStart(2, '0'); 
        let year = date.getFullYear();
        return `${day}/${month}/${year}`;
    },
    formatDate(value) {
      if (!value) return "";
      let date = new Date(value);
      date.setDate(date.getDate() + 1);  // Ajusta a data para corrigir o problema
      let day = String(date.getDate()).padStart(2, '0');
      let month = String(date.getMonth() + 1).padStart(2, '0');
      let year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },
    formatCurrencyZero(value) {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value)
    },
    formatTimestampDiaSemana(timestamp) {
      if (timestamp) {
        const date = new Date(timestamp);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const weekDay = date.toLocaleDateString('pt-BR', { weekday: 'long' });

        return `${day}/${month}/${year} - ${weekDay.charAt(0).toUpperCase() + weekDay.slice(1)}`;
      }
      return '';
    },
    formatTime(value) {
      if (!value) return '';
      const parts = value.split(':');
      return parts[0] + ':' + parts[1];  // HH:MM
    },
  },
  computed: {
    // Verificar se tem informações no endpooint, caso sonctrário mostrará apenas uma meg de nao tem informações
    hasInformation() {
      return this.item && (
        this.item.texto_evolucao ||
        this.item.texto_meta ||
        this.item.texto_info ||
        this.item.timestamp_sign
      );
    }
  },
};
</script>

<style scoped>
  /*  */
</style>
